// extracted by mini-css-extract-plugin
export default {"icon":"MapPopUp_icon__49hZv","Modal":"MapPopUp_Modal__GKIcj"};